import { FiEye } from 'react-icons/fi';
import { formatDate } from '../../../../../utlis';
import MyTable from '../../../../../components/MyTable';

const SystemConfigsTable = ({ data, onViewConfig, onTypeClick, pageSize, onPageSizeChange }) => {
  // Transform data to ensure consistent field names
  const transformedData = data.map((config) => ({
    id: config.id || '',
    client: config.client || '',
    company: config.company || '',
    division: config.division || '',
    type: config.type || '',
    created_by: config.created_by || '',
    created: config.created || '',
    updated_by: config.updated_by || '',
    updated: config.updated || '',
  }));

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        display: false,
      },
    },
    {
      name: 'client',
      label: 'Client',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0];
          return (
            <h3
              onClick={() => onViewConfig && onViewConfig(id)}
              className="text-base font-bold text-auxiliary-800 cursor-pointer hover:underline"
            >
              {value || 'N/A'}
            </h3>
          );
        },
      },
    },
    {
      name: 'company',
      label: 'Company',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <p className="text-text-hint">{value || 'N/A'}</p>
        ),
      },
    },
    {
      name: 'division',
      label: 'Division',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || 'N/A',
      },
    },
    {
      name: 'type',
      label: 'Type',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0];
          return (
            <button
              onClick={() => onTypeClick && onTypeClick(id)}
              className="px-3 py-1 bg-secondary-100 text-secondary-700 rounded text-sm font-medium hover:bg-secondary-200 cursor-pointer transition"
            >
              {value || 'N/A'}
            </button>
          );
        },
      },
    },
    {
      name: 'created_by',
      label: 'Created By',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || 'N/A',
      },
    },
    {
      name: 'created',
      label: 'Date Created',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (value ? formatDate(value) : 'N/A'),
      },
    },
    {
      name: 'updated_by',
      label: 'Updated By',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || 'N/A',
      },
    },
    {
      name: 'updated',
      label: 'Last Updated',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (value ? formatDate(value) : 'N/A'),
      },
    },
    {
      name: 'actions',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const configId = tableMeta.rowData[0];
          return (
            <button
              onClick={() => onViewConfig && onViewConfig(configId)}
              className="p-2 hover:bg-gray-200 rounded-full"
              title="View Configuration"
            >
              <FiEye size={16} className="text-secondary-700" />
            </button>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    rowsPerPage: pageSize,
    rowsPerPageOptions: [5, 10, 15, 20, 50],
    onChangeRowsPerPage: (numberOfRows) => onPageSizeChange(numberOfRows),
    selectableRows: 'none',
    elevation: 0,
    download: true,
    print: true,
    search: false,
    viewColumns: true,
    filter: true,
  };

  return (
    <div className="w-full overflow-x">
      <MyTable
        title=""
        data={transformedData}
        columns={columns}
        options={options}
      />
    </div>
  );
};

export default SystemConfigsTable;
